export enum manaNewsOrderBy {
  CreationDateDescending = 1,
  CreationDateAscending,
  ReactionsDescending,
  ReactionsAscending,
  CommentsDescending,
  CommentsAscending
}
